import { useField, useFormikContext } from "formik";
import { RenderContainer } from "../RenderContainer";
import { useEffect, useState } from "react";
import { Renderer, Renderer2, RendererProps } from "../model";
import _ from "lodash";
import { Dropdown, SelectOption } from "components/dropdown/Dropdown";

const CustomSingleSelect: React.FC<RendererProps> = ({
  customField,
  index,
  readOnly,
  handleOnChange,
  field,
}) => {
  const { setFieldValue } = useFormikContext();
  const [readOnlyValue, setReadOnlyValue] = useState<string | null>(null);
  const [{ value }] = useField(field.name);
  const options = customField.possibleValues.map(
    (values: { value: string; id: number }) => ({
      label: values.value,
      value: values.id,
    })
  );
  const [selectedValue, setSelectedValue] = useState<SelectOption | null>(null);
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  const onChange = (selectedOption: SelectOption) => {
    const tempValues = _.cloneDeep(value);

    tempValues[index] = {
      ...tempValues[index],
      possibleValuesId: selectedOption.value,
    };
    setSelectedValue(selectedOption);
    setFieldValue(field.name, [...tempValues]);
  };
  return (
    <RenderContainer customFieldName={customField.name}>
      {readOnly ? (
        <input
          className={`EditBox ${readOnly ? "ViewOnly" : ""}`}
          value={readOnlyValue ? (readOnlyValue as string) : "No data"}
          readOnly={readOnly}
        />
      ) : (
        <div className={`CustomSingleSelect ${menuOpen ? "MenuOpen" : ""}`}>
          <Dropdown
            options={options}
            value={selectedValue}
            onChange={onChange}
            placeholder="Select..."
            isSearchable={true}
            onMenuOpen={() => setMenuOpen(true)} // NOTE: This is needed to make click on mobile phones work
            onMenuClose={() => setMenuOpen(false)} // NOTE: This is needed to make click on mobile phones work
          />
        </div>
      )}
    </RenderContainer>
  );
};

export const customSingleSelect: Renderer2 = (
  customField,
  index,
  readOnly,
  handleOnChange,
  field,
  isMulti,
  classWrapper,
  booleanField
) => (
  <CustomSingleSelect
    customField={customField}
    index={index}
    readOnly={readOnly}
    handleOnChange={handleOnChange}
    field={field}
    isMulti={isMulti}
    classWrapper={classWrapper}
    booleanField={booleanField}
  />
);
